import { memo } from 'react';
import UITextInput from 'UIComponents/input/UITextInput';
// @ts-expect-error untyped deps
import UIValidatedUrlFormControl from 'ui-addon-form-validation/Url/UIValidatedUrlFormControl';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultValidationMessage = {
  success: '',
  error: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataProperties.propertyValidationErrorMessages.invalidUrl"
  })
};
const PropertyInputUrl = props => {
  const {
    onChange,
    inputRef,
    value
  } = props;
  const transferrableProps = getTransferrableProps(props);
  return /*#__PURE__*/_jsx(UIValidatedUrlFormControl, {
    type: "basic",
    requireProtocol: true,
    validationMessage: defaultValidationMessage,
    children: /*#__PURE__*/_jsx(UITextInput, Object.assign({}, transferrableProps, {
      value: value || '',
      onChange: onChange,
      inputRef: inputRef
    }))
  });
};
export default /*#__PURE__*/memo(PropertyInputUrl);